var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":_vm.SETTING['productLink']}},[_vm._v(_vm._s(_vm.SETTING['product']))]),_vm._v(" © "+_vm._s(_vm.currentYear)+" "+_vm._s(_vm.SETTING['system'])+".")]),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("Powered by "),_c('a',{attrs:{"href":_vm.SETTING['productLink']}},[_vm._v(_vm._s(_vm.SETTING['product']))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70fbc2b0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 886
// module chunks = 1